import {handleActions} from 'redux-actions'
import * as ActionTypes from "./actionTypes"
import {BulkOperationType} from './constants'

const initState = {
    operationProcessing: false,
    operationProgress: null,
    currentOperation: null,
    deleteDialogData: {
        loading: false,
        taskIds: [],
        entitiesBlockedCount: [],
        entitiesBlocked: [],
    },
    assignToDialogData: {
        loading: false,
        numberOfTasks: 0,
        canModifyAny: true,
        timeZoneGroups: [],
        timeZoneGroupsEnabled: false,
        userGroups: [],
        userGroupsEnabled: false,
        users: [],
        selectedUserIds: [],
        userRatesEnabled: false,
        billingTypesEnabled: false,
    },
    changeStatusDialogData: {
        loading: false,
        taskIds: [],
    },
    moveDialogData: {
        loading: false,
        taskIds: [],
        notAvailableToMoveTasks: [],
        includeOpenTasks: true,
    },
}

export default handleActions({
    [ActionTypes.START_BULK_TASKS_DELETE_OPERATION]: (state) => ({
        ...state,
        currentOperation: BulkOperationType.DELETE
    }),

    [ActionTypes.LOAD_BULK_DELETE_DIALOG_DATA]: (state) => ({
        ...state,
        deleteDialogData: {
            ...state.deleteDialogData,
            loading: true
        }
    }),
    [ActionTypes.LOAD_BULK_DELETE_DIALOG_DATA_SUCCESS]: (state, {payload: data}) => ({
        ...state,
        deleteDialogData: {
            ...state.deleteDialogData,
            ...data,
            loading: false
        }
    }),
    [ActionTypes.LOAD_BULK_DELETE_DIALOG_DATA_FAILURE]: (state) => ({
        ...state,
        deleteDialogData: {
            ...state.deleteDialogData,
            loading: false
        }
    }),

    [ActionTypes.BULK_TASKS_DELETE]: (state) => ({
        ...state,
        operationProcessing: true,
        operationProgress: 0,
    }),
    [ActionTypes.BULK_TASKS_DELETE_SUCCESS]: (state) => ({
        ...state,
        operationProcessing: false,
        currentOperation: null,
        operationProgress: null,
    }),
    [ActionTypes.BULK_TASKS_DELETE_FAILURE]: (state) => ({
        ...state,
        operationProcessing: false,
        operationProgress: null,
    }),

    [ActionTypes.START_BULK_ASSIGN_TASKS_OPERATION]: (state) => ({
        ...state,
        currentOperation: BulkOperationType.CHANGE_ASSIGNMENTS,
    }),

    [ActionTypes.LOAD_BULK_ASSIGN_DIALOG_DATA]: (state) => ({
        ...state,
        assignToDialogData: {
            ...state.assignToDialogData,
            loading: true
        }
    }),
    [ActionTypes.LOAD_BULK_ASSIGN_DIALOG_DATA_SUCCESS]: (state, {payload: data}) => ({
        ...state,
        assignToDialogData: {
            ...state.assignToDialogData,
            ...data,
            loading: false
        }
    }),
    [ActionTypes.LOAD_BULK_ASSIGN_DIALOG_DATA_FAILURE]: (state) => ({
        ...state,
        assignToDialogData: {
            ...state.assignToDialogData,
            loading: false
        }
    }),
    [ActionTypes.BULK_ASSIGN_DIALOG_SELECTION_SET]: (state, {payload: selectedUserIds}) => ({
        ...state,
        assignToDialogData: {
            ...state.assignToDialogData,
            selectedUserIds,
            loading: false
        }
    }),

    [ActionTypes.BULK_ASSIGN_TASKS]: (state) => ({
        ...state,
        operationProcessing: true,
        operationProgress: 0,
    }),
    [ActionTypes.BULK_ASSIGN_TASKS_SUCCESS]: (state) => ({
        ...state,
        operationProcessing: false,
        currentOperation: null,
        operationProgress: null,
    }),
    [ActionTypes.BULK_ASSIGN_TASKS_FAILURE]: (state) => ({
        ...state,
        operationProcessing: false,
        operationProgress: null,
    }),

    [ActionTypes.START_BULK_CHANGE_TASKS_STATUS_OPERATION]: (state) => ({
        ...state,
        currentOperation: BulkOperationType.CHANGE_STATUS,
    }),

    [ActionTypes.LOAD_BULK_CHANGE_STATUS_DIALOG_DATA]: (state) => ({
        ...state,
        changeStatusDialogData: {
            ...state.changeStatusDialogData,
            loading: true,
        }
    }),
    [ActionTypes.LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_SUCCESS]: (state, {payload: data}) => ({
        ...state,
        changeStatusDialogData: {
            ...state.changeStatusDialogData,
            ...data,
            loading: false,
        }
    }),
    [ActionTypes.LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_FAILURE]: (state) => ({
        ...state,
        changeStatusDialogData: {
            ...state.changeStatusDialogData,
            loading: false,
        }
    }),

    [ActionTypes.BULK_CHANGE_TASKS_STATUS]: (state) => ({
        ...state,
        operationProcessing: true,
        operationProgress: 0,
    }),
    [ActionTypes.BULK_CHANGE_TASKS_STATUS_SUCCESS]: (state) => ({
        ...state,
        operationProcessing: false,
        currentOperation: null,
        operationProgress: null,
    }),
    [ActionTypes.BULK_CHANGE_TASKS_STATUS_FAILURE]: (state) => ({
        ...state,
        operationProcessing: false,
        operationProgress: null,
    }),

    [ActionTypes.START_BULK_MOVE_OPERATION]: (state) => ({
        ...state,
        currentOperation: BulkOperationType.MOVE
    }),

    [ActionTypes.LOAD_BULK_MOVE_DIALOG_DATA]: (state) => ({
        ...state,
        moveDialogData: {
            ...state.moveDialogData,
            loading: true
        }
    }),

    [ActionTypes.LOAD_BULK_MOVE_DIALOG_DATA_SUCCESS]: (state, {payload: data}) => ({
        ...state,
        moveDialogData: {
            ...state.moveDialogData,
            ...data,
            loading: false
        }
    }),

    [ActionTypes.LOAD_BULK_MOVE_DIALOG_DATA_FAILURE]: (state) => ({
        ...state,
        moveDialogData: {
            ...state.moveDialogData,
            loading: false
        }
    }),

    [ActionTypes.BULK_TASKS_MOVE]: (state) => ({
        ...state,
        operationProcessing: true,
        operationProgress: 0,
    }),

    [ActionTypes.BULK_TASKS_MOVE_SUCCESS]: (state) => ({
        ...state,
        operationProcessing: false,
        currentOperation: null,
        operationProgress: null,
    }),

    [ActionTypes.BULK_TASKS_MOVE_FAILURE]: (state) => ({
        ...state,
        operationProcessing: false,
        operationProgress: null,
    }),

    [ActionTypes.START_BULK_COPY_OPERATION]: (state) => ({
        ...state,
        currentOperation: BulkOperationType.COPY
    }),

    [ActionTypes.BULK_TASKS_COPY]: (state) => ({
        ...state,
        operationProcessing: true,
        operationProgress: 0,
    }),

    [ActionTypes.BULK_TASKS_COPY_SUCCESS]: (state) => ({
        ...state,
        operationProcessing: false,
        currentOperation: null,
        operationProgress: null,
    }),

    [ActionTypes.BULK_TASKS_COPY_FAILURE]: (state) => ({
        ...state,
        operationProcessing: false,
        operationProgress: null,
    }),

    [ActionTypes.BULK_OPERATION_PROGRESS_SET]: (state, {payload: operationProgress}) => ({
        ...state,
        operationProgress
    }),

    [ActionTypes.CLEANUP_DIALOGS_DATA]: (state) => ({
        ...state,
        operationProcessing: false,
        operationProgress: null,
        currentOperation: null,
        deleteDialogData: {
            loading: false,
            entitiesBlockedCount: [],
            entitiesBlocked: [],
        },
        changeStatusDialogData: {
            loading: false,
            taskIds: [],
        },
        assignToDialogData: {
            loading: false,
            numberOfTasks: 0,
            canModifyAny: true,
            timeZoneGroups: [],
            timeZoneGroupsEnabled: false,
            userGroups: [],
            userGroupsEnabled: false,
            users: [],
        },
    }),
}, initState)



// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/reducer.js